<template>

<div>
  <v-container grid-list-md class="mt-3 mb-3 "  style="max-width:2000px"> 
      <v-layout row wrap >
          <v-flex xs12 sm6 md4 v-for="artefact in artefacts_scroll"  :key="artefact._id">

      <web-artefact-card :artefact='artefact' ></web-artefact-card>
        
          </v-flex>
        
      </v-layout>

          <web-speed-dial-add v-if="isMod||isContrib"></web-speed-dial-add>

  </v-container>

  <div id="getNewArtefacts"></div>

  <div v-if="isAdmin" style="width:100vw; height:67px;">

  </div>
</div>
  
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
export default {
  components: {
    InfiniteLoading
  },
  data() {
    return {
      end:12,
      list: [],
      direction: "left",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",
      gradient: "to top right, rgba(63,81,181, .7), rgba(25,32,72, .0)"
    };
  },
  computed: {
    artefacts_scroll(){
      return this.artefacts.slice(0,this.end)
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    collectionName() {
      return this.$store.getters.getCollectionName(this.id);
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
        isMod() {
      return this.$store.getters.isMod;
    },
        isContrib() {
      return this.$store.getters.isContrib;
    }
  },
  mounted: function() {
    document.title = "Artefacts";
    window.scrollTo(0, 0);
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadUsers");
     
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll(){
      const elem=document.getElementById("getNewArtefacts")
      if(this.isScrolledIntoView(elem) && this.artefacts_scroll.length < this.artefacts.length)
      {
        this.end = this.end + 6;
      }
    },
    isScrolledIntoView(el) {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;

    // Only completely visible elements return true:
    var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    // Partially visible elements return true:
    //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    return isVisible;
    },
    infiniteHandler($state) {
      setTimeout(() => {
        const temp = [];
        let a = 0;
        if (this.artefacts.length != this.list.length) {
          if (this.artefacts.length - this.list.length < 2) {
            a = this.artefacts.length - this.list.length - 1;
          } else {
            a = this.list.length + 2;
          }
          for (let i = this.list.length ; i <= a; i++) {
            temp.push(this.artefacts[i]);
          }
          this.list = this.list.concat(temp);
          $state.loaded();
        } else {
          $state.complete();
        }
      }, 1000);
    }
    //   moveButton(admin) {
    //       if(admin) {
    //         var btn = document.getElementById('bottom_button');
    //         btn.style.bottom = '65px';

    //       }
    //       else
    //       {
    //         var btn = document.getElementById('bottom_button');
    //         btn.style.bottom = '15px';
    //       }

    //     }
  },
 
};
</script>


<style scoped>
/* .card__media__background:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(to bottom right,#000000,#000000);
  opacity: .7; 
  } */
.headline {
  position: absolute;
  bottom: 3%;
  left: 3%;
}
</style>


// WEBPACK FOOTER //
// src/components/Common/Artefacts.vue